/* global $ */

// This code carries the url params that a user lands on a site with through
// to a donation url, allowing refcode/source/etc to carry over

import {
	gup,
	decodeParameterString,
	encodeParameterString,
} from '../helpers/params';
import { parseUrl } from '../helpers/urls';
import { getCookie, setSessionCookie } from '../helpers/cookies';

// creates an object of all the parameters
// eslint-disable-next-line no-unused-vars
const urlParams = decodeParameterString(window.location.search);

// Add dynamic sourcing to contribution link
$.$body.find('header .contribute-link a').each(function() {
	const $this = $(this);
	const url = parseUrl($this.attr('href')); // DOM node a tag, similar to window.location
	const source = getCookie('_source') || gup('source') || 'website';
	const refcode = getCookie('_refcode') || gup('refcode');

	const existingLinkParams = decodeParameterString(url.search);

	// not sensible by default, but we can iterate through url params
	// to decide which to pass through with more complex logic, like this
	//
	// Object.keys(urlParams).forEach((param) => {
	//   if (
	//     param.indexOf('refcode') > -1 ||
	//     param.indexOf('source') > -1 ||
	//     param.indexOf('amount') > -1
	//   ) {
	//     existingParams[param] = urlParams[param];
	//   }
	// });

	if (refcode) {
		existingLinkParams.refcode = refcode;
	}
	existingLinkParams.source = source;
	url.search = encodeParameterString(existingLinkParams);

	$this.attr('href', url.href);

	setSessionCookie('_source', source);
	setSessionCookie('_refcode', source);
});
